import React from "react";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import Section from "../Section";
import parse from "html-react-parser";
import { pageTitle } from "../../helpers/PageTitle";
const timeTable = [
  {
    day: "Senin",
    schedules: [
      {
        hour: 1,
        department: "Poli Bedah 19.00 - 21.00",
        doctor: "dr. Herman Susilo, Sp. B, M. Kes",
      },
      {
        hour: 1.1,
        department: "Poli Kandungan 09:00 - 11:00",
        doctor: "di. I Wayan Subage, Sp. OG",
      },
      {
        hour: 1.1,
        department: "Poli Saraf 16.00 - 19.00",
        doctor: "dr. Bram Arfian Putra, Sp. N",
      },
      {
        hour: 1.1,
        department: "Poli Penyakit Dalam <br />16:00 - 20.00",
        doctor: "dr. Arwindy Almar, Sp. PD., FINASIM",
      },
      {
        hour: 1.1,
        department: "Poli Anak <br />15:00 - 18:00",
        doctor: "dr. Lia Kamelia, Sp. A., M. Kes",
      },
      {
        hour: 1.1,
        department: "Poli THT-KL <br />15:00 - 17:00",
        doctor: "dr. Hermawan Sutanto, Sp. THT-KL",
      },
      {
        hour: 1.1,
        department: "Poli Kulit & Kelamin <br />14:00 - Selesai",
        doctor: "dr. Hari Purwanto, sp. D.V",
      },
      {
        hour: 1,
        department: "Poli Kandungan <br />16:00 - 20:00",
        doctor: "dr. Hasan basri, Sp. OG",
      },
      {
        hour: 1,
        department: "Poli Mata <br />10:00 - 14:00",
        doctor: "dr. ferdiansyah, Sp. M",
      },
      {
        hour: 1.1,
        department: "Radiologi <br /> Dengan perjanjian",
        doctor: "Dr.dr. Anse Diana V.M, Sp. Rad (K)",
      },
      {
        hour: 1,
        department: "Poli Gigi <br /> 15:00 - 18:00",
        doctor: "drg. Iksan Tino Pribadi",
      },
    ],
  },
  {
    day: "Selasa",
    schedules: [
      { hour: 1, department: "", doctor: "", roomNumber: "" },
      {
        hour: 2,
        department:
          "Obstetrics and Gynecology Department <br />9:00 AM - 11:00 AM",
        doctor: "Dr. Karen Lee",
        roomNumber: "Room 401",
      },
      {
        hour: 3,
        department: "Pulmonology Department <br />11:00 AM - 2:00 PM",
        doctor: "Dr. John Smith",
        roomNumber: "Room 502",
      },

      {
        hour: 3,
        department: "Neurology Department <br />3:00 PM - 6:00 PM",
        doctor: "Dr. Maria Rodriguez",
        roomNumber: "Room 603",
      },
      {
        hour: 3,
        department: "Emergency Department <br />6:00 PM - 9:00 PM",
        doctor: "Dr. Michael Johnson <br />Dr. Lisa Chen",
        roomNumber: "Emergency Room",
      },
    ],
  },
  {
    day: "Rabu",
    schedules: [
      {
        hour: 4,
        department: "Pediatric Department <br />9:00 AM - 11:00 AM",
        doctor: "Dr. Sarah Patel <br />Dr. David Nguyen",
        roomNumber: "Room 101",
      },
      { hour: 1, department: "", doctor: "", roomNumber: "" },
      {
        hour: 3,
        department: "Cardiology Department <br />1:00 PM - 4:00 PM",
        doctor: "Dr. James Lee <br />Dr. Michelle Kim",
        roomNumber: "Room 202",
      },
      {
        hour: 2,
        department: "Psychiatry Department <br />4:00 PM - 6:00 PM",
        doctor: "Dr. Rachel Jones <br />Dr. David Park",
        roomNumber: "Room 303",
      },
      {
        hour: 3,
        department: "Physical Therapy Department <br />6:00 PM - 9:00 PM",
        doctor: "Dr. Susan Kim",
        roomNumber: "Gymnasium",
      },
    ],
  },
  {
    day: "kamis",
    schedules: [
      { hour: 1, department: "", doctor: "", roomNumber: "" },
      {
        hour: 2,
        department:
          "Obstetrics and Gynecology Department <br />9:00 AM - 11:00 AM",
        doctor: "Dr. Karen Lee",
        roomNumber: "Room 401",
      },
      {
        hour: 3,
        department: "Pulmonology Department <br />11:00 AM - 2:00 PM",
        doctor: "Dr. John Smith",
        roomNumber: "Room 502",
      },
      {
        hour: 3,
        department: "Neurology Department <br />3:00 PM - 6:00 PM",
        doctor: "Dr. Maria Rodriguez",
        roomNumber: "Room 603",
      },
      {
        hour: 4,
        department: "Emergency Department <br />5:00 PM - 9:00 PM",
        doctor: "Dr. Michael Johnson <br />Dr. Lisa Chen",
        roomNumber: "Emergency Room",
      },
    ],
  },
  {
    day: "Jumat",
    schedules: [
      {
        hour: 4,
        department: "Pediatric Department <br />9:00 AM - 11:00 AM",
        doctor: "Dr. Sarah Patel <br />Dr. David Nguyen",
        roomNumber: "Room 101",
      },
      {
        hour: 3,
        department: "Cardiology Department <br />12:00 PM - 3:00 PM",
        doctor: "Dr. James Lee <br />Dr. Michelle Kim",
        roomNumber: "Room 202",
      },
      {
        hour: 3,
        department: "Psychiatry Department <br />3:00 PM - 6:00 PM",
        doctor: "Dr. Rachel Jones <br />Dr. David Park",
        roomNumber: "Room 303",
      },
      {
        hour: 2,
        department: "Physical Therapy Department <br />6:00 PM - 9:00 PM",
        doctor: "Dr. Susan Kim",
        roomNumber: "Gymnasium",
      },
      { hour: 1, department: "", doctor: "", roomNumber: "" },
    ],
  },

  {
    day: "Sabtu",
    schedules: [
      { hour: 1, department: "", doctor: "", roomNumber: "" },
      {
        hour: 3,
        department:
          "Obstetrics and Gynecology Department <br />9:00 AM - 12:00 AM",
        doctor: "Dr. Karen Lee",
        roomNumber: "Room 401",
      },
      {
        hour: 2,
        department: "Pulmonology Department <br />12:00 AM - 2:00 PM",
        doctor: "Dr. John Smith",
        roomNumber: "Room 502",
      },
      { hour: 1, department: "", doctor: "", roomNumber: "" },
      {
        hour: 2,
        department: "Neurology Department <br />3:00 PM - 6:00 PM",
        doctor: "Dr. Maria Rodriguez",
        roomNumber: "Room 603",
      },
      {
        hour: 4,
        department: "Emergency Department <br />5:00 PM - 9:00 PM",
        doctor: "Dr. Michael Johnson <br />Dr. Lisa Chen",
        roomNumber: "Emergency Room",
      },
    ],
  },
];

export default function jadwaldokter() {
  pageTitle("Jadwal Dokter");
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/home_1/hero_bg.png"
        imgUrl="/images/timetable/head.png"
        title="Jadwal Praktek Dokter <br>RS Mutiara Bunda"
        subTitle="*Jadwal dapat berubah sewaktu-waktu"
      />
      <Section
        topMd={170}
        topLg={170}
        topXl={170}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <div className="container">
          <img src="/images/jadwal/jadwal.jpg" alt="" />
        </div>
      </Section>
    </>
  );
}
